/**
 * Logger Utility
 * Provides consistent logging across the application
 * Only logs to console in development mode
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Debug level logging (only in development)
   * Use for detailed information useful during development
   */
  debug: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  },

  /**
   * Info level logging (only in development)
   * Use for general informational messages
   */
  info: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      console.info(`[INFO] ${message}`, ...args);
    }
  },

  /**
   * Warning level logging (always logged)
   * Use for potentially harmful situations
   */
  warn: (message: string, ...args: unknown[]): void => {
    console.warn(`[WARN] ${message}`, ...args);
  },

  /**
   * Error level logging (always logged)
   * Use for error events that might still allow the app to continue
   */
  error: (message: string, error?: Error | unknown, ...args: unknown[]): void => {
    console.error(`[ERROR] ${message}`, error, ...args);
    
    // TODO: Send to error tracking service (Sentry, LogRocket, etc.)
    // if (error instanceof Error) {
    //   trackError(error, { message, ...args });
    // }
  },

  /**
   * Group logging for related messages
   */
  group: (label: string): void => {
    if (isDev) {
      console.group(label);
    }
  },

  groupEnd: (): void => {
    if (isDev) {
      console.groupEnd();
    }
  },
};

export default logger;
